import { safeAbi } from "@mezo-org/orangekit-contracts";
import { getContract } from "viem";
import { toNetwork } from "./network";
import SafeFactory from "./safe-factory";
function createSafeContract(safeAddress, client) {
    const safeContract = getContract({
        address: safeAddress,
        abi: safeAbi,
        client,
    });
    return {
        getAddress: () => safeContract.address,
        getSafeOwnerAddress: async () => {
            const [safeOwner] = await safeContract.read.getOwners();
            return safeOwner;
        },
        nonce: async () => {
            const nonce = await safeContract.read.nonce();
            return Number(nonce);
        },
        getAbi: () => safeContract.abi,
    };
}
// eslint-disable-next-line import/prefer-default-export
export function getEthereumContracts(client, chainId) {
    const network = toNetwork(chainId);
    if (!network)
        throw new Error("Unsupported network");
    const safeFactory = new SafeFactory(client);
    return {
        safeFactory,
        getSafeContract: (address) => createSafeContract(address, client),
    };
}
//# sourceMappingURL=index.js.map